/* eslint-disable react/jsx-fragments */
import React, { useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { GlobalStyles } from './Style/globalStyles'
import { useClientTheme } from './Style/useClientTheme'
import { lightTheme } from './Themes'
import PropTypes from 'prop-types'

const Client = ({ toggleTheme }) => {
  return <React.Fragment />
}
Client.propTypes = {
  toggleTheme: PropTypes.func.isRequired
}
const Theme = () => {
  const [theme, themeToggler] = useClientTheme()
  const themeMode = theme === 'light' ? lightTheme : lightTheme

  useEffect(() => {
    const timer = setTimeout(() => {}, 1)
    return () => clearTimeout(timer)
  }, [])
  // if (!mountedComponent) return <div />;
  return (
    <ThemeProvider theme={themeMode}>
      <GlobalStyles />
      <Client className="light" theme={theme} toggleTheme={themeToggler} />
    </ThemeProvider>
  )
}

export default Theme
